/**
 * @description Returns the current window's base url.
 * @example https://aoc-test-frontdoor.azurefd.net, or https://localhost:3000
 * @return {string} - the base url
 */
export const getBaseUrl = () => {
    let uri = `${window.location.protocol}//${window.location.hostname}`;
    if (uri.includes("localhost")) {
      uri = `${uri}:${window.location.port}`;
    }
    return uri;
  };

/**
 * Generates a cryptographically secure random number between 0 and 1
 * @returns A secure random number between 0 and 1
 */
export const getSecureRandom = (): number => {
    // Create a new 32-bit array with 1 element
    const array = new Uint32Array(1);
    // Fill it with secure random values
    crypto.getRandomValues(array);
    // Convert to number between 0 and 1
    return array[0] / (0xffffffff + 1);
};

/**
 * Null-safe string normalization helper.
 * Converts null/undefined to empty string, then trims whitespace.
 */
export const toTrimmedString = (value?: string | null): string => {
  return (value ?? "").trim();
};

/**
 * Extracts the YYYY-MM-DD date portion from a string or Date.
 * For strings (e.g. "2026-07-13T10:36:00" from the API), uses regex to avoid
 * timezone offset shifting the date. For Date objects, returns the UTC date via toISOString().
 */
export function extractDatePart(value: string | Date | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string') {
    const m = value.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }
  const d = value as Date;
  if (isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

